@if (!availableDivisionInfos.noAvailableDivisions) {
  <div class="re-space-y-30">
    @for (availableDivision of availableDivisionInfos?.availableDivisions; track availableDivision) {
      <div>
        @if (availableDivision.isProvided === false || canceledDivisionIds.includes(availableDivision.divisionId)) {
          <div>
            <div class="re-flex re-flex-row re-items-center">
              <svg-icon [applyClass]="true" class="re-text-brand-primary re-w-30 re-h-30" src="assets/icons/system_icons/alert.svg"></svg-icon>
              <h5 class="re-ml-10">{{availableDivision.divisionId | verbrauchstyp}}</h5>
            </div>
            @if (availableDivision.isProvided === false) {
              <div data-qa="tariffs-overview-text-not-provided">
                {{ 'tariff.overview.noDelivery.outsideSupplyArea' | translate }}
              </div>
            }
            @if (canceledDivisionIds.includes(availableDivision.divisionId) && !impossibleDivisionIds.includes(availableDivision.divisionId)) {
              <div data-qa="tariffs-overview-text-not-provided">
                {{ 'tariff.overview.noDelivery.cancel' | translate: { division: availableDivision.divisionId | verbrauchstyp } }}
              </div>
            }
          </div>
        } @else {
          @if (getTariffByDivisionId(availableDivision.divisionId)) {
            <div class="re-flex re-flex-row re-items-center">
              <svg-icon [applyClass]="true" class="icon re-text-monochrome re-stroke-current re-fill-current re-w-30 re-h-30" src="assets/icons/system_icons/ok-circle.svg"></svg-icon>
              <h5 class="re-ml-10">{{ availableDivision.divisionId | verbrauchstyp }}</h5>
            </div>
            <ng-container #newTariff>
              <div data-qa="tariffs-overview-text">
                {{ 'tariff.overview.deliveryBegin' | translate: { tariffName: getTariffTitleByDivisionId(availableDivision.divisionId) } }}
              </div>
            </ng-container>
          }
        }

      </div>
    }
  </div>
} @else {
  @if (availableDivisionInfos.noAvailableDivisions === true) {
    <div data-qa="no-divisions-available"
    [innerHTML]="'tariff.overview.noDelivery.noDivisionsAvailable' | translate"></div>
  }
}

